var componentPanelsPath = '{,*/}%ComponentName%/editor/panels';
var componentDocumentManagementPath = '{,*/}%ComponentName%/documentManagement';
export var hostConfigs = {
    documentManagement: {
        entries: {
            generateParts: false,
            generateComponents: false,
            generateHost: true,
        },
        shouldIncludeComponentsInfo: false,
        conventions: [
            {
                part: 'hooks',
                path: componentDocumentManagementPath + "/%ComponentName%.hooks.ts",
            },
            {
                part: 'dataSchema',
                path: componentDocumentManagementPath + "/%ComponentName%.dataSchema.ts",
            },
            {
                part: 'metaData',
                path: componentDocumentManagementPath + "/%ComponentName%.metadata.ts",
            },
            {
                part: 'propertiesSchema',
                path: componentDocumentManagementPath + "/%ComponentName%.propsSchema.ts",
            },
            {
                part: 'componentDefinition',
                path: componentDocumentManagementPath + "/%ComponentName%.definition.ts",
            },
        ],
    },
    dataBinding: {
        entries: {
            generateParts: false,
            generateComponents: true,
            generateHost: true,
        },
        shouldIncludeComponentsInfo: false,
        getComponentName: function (_a) {
            var componentName = _a.componentName;
            return "$w." + componentName;
        },
        conventions: [
            {
                part: 'dataBindingPanel',
                path: '{,*/}editor/panels/dataBinding/%ComponentName%.dataBindingPanel.ts',
            },
        ],
    },
    editor: {
        entries: {
            generateParts: true,
            generateComponents: true,
            generateHost: true,
        },
        shouldIncludeComponentsInfo: false,
        conventions: [
            {
                part: 'settingsPanel',
                path: componentPanelsPath + "/settings/%ComponentName%.settingsPanel.tsx",
            },
            {
                part: 'layoutPanel',
                path: componentPanelsPath + "/layout/%ComponentName%.layoutPanel.tsx",
            },
            {
                part: 'managePanel',
                path: componentPanelsPath + "/manage/%ComponentName%.managePanel.tsx",
            },
            {
                part: 'backgroundPanel',
                path: componentPanelsPath + "/background/%ComponentName%.backgroundPanel.tsx",
            },
            {
                part: 'stylablePanel',
                path: componentPanelsPath + "/stylable/%ComponentName%.stylablePanel.ts",
            },
            {
                part: 'gfpp',
                path: '{,*/}%ComponentName%/editor/%ComponentName%.gfpp.ts',
            },
            {
                part: 'metadata',
                path: '{,*/}%ComponentName%/editor/%ComponentName%.editorMetadata.ts',
            },
        ],
    },
    editorX: {
        entries: {
            generateParts: false,
            generateComponents: false,
            generateHost: true,
        },
        shouldIncludeComponentsInfo: false,
        conventions: [
            {
                part: 'externalComponentEditor',
                path: '{,*/}editor/%ComponentName%.responsiveMetadata.ts',
            },
            {
                part: 'componentAddPanel',
                path: '{,*/}editor/%ComponentName%.responsiveAddPanel.ts',
            },
        ],
    },
    thunderbolt: {
        entries: {
            generateParts: false,
            generateComponents: true,
            generateHost: true,
        },
        shouldIncludeComponentsInfo: true,
        getComponentName: function (_a) {
            var componentName = _a.componentName, placeholders = _a.placeholders;
            if (placeholders.SkinName) {
                return componentName + "_" + placeholders.SkinName;
            }
            return componentName;
        },
        part: 'component',
        path: '{,*/}%ComponentName%/viewer/{%ComponentName%.tsx,skinComps/*/%SkinName%.skin.tsx}',
        conventions: [
            {
                part: 'controller',
                path: '{,*/}%ComponentName%/viewer/%ComponentName%.controller.ts',
            },
        ],
    },
    thunderboltPreview: {
        entries: {
            generateParts: false,
            generateComponents: false,
            generateHost: true,
        },
        shouldIncludeComponentsInfo: false,
        getComponentName: function (_a) {
            var componentName = _a.componentName, placeholders = _a.placeholders;
            if (placeholders.SkinName) {
                return componentName + "_" + placeholders.SkinName;
            }
            return componentName;
        },
        part: 'component',
        path: '{,*/}%ComponentName%/viewer/{%ComponentName%.tsx,skinComps/*/%SkinName%.skin.tsx}',
        conventions: [
            {
                part: 'previewWrapper',
                path: '{,*/}%ComponentName%/viewer/%ComponentName%.previewWrapper.tsx',
            },
            {
                part: 'previewMapper',
                path: '{,*/}%ComponentName%/viewer/%ComponentName%.previewMapper.ts',
            },
            {
                part: 'mapper',
                path: '{,*/}%ComponentName%/viewer/%ComponentName%.mapper.ts',
            },
            {
                part: 'controller',
                path: '{,*/}%ComponentName%/viewer/%ComponentName%.controller.ts',
            },
        ],
    },
    siteAssets: {
        entries: {
            generateParts: false,
            generateComponents: false,
            generateHost: true,
        },
        shouldIncludeComponentsInfo: false,
        getComponentName: function (_a) {
            var componentName = _a.componentName;
            return componentName;
        },
        conventions: [
            {
                part: 'mapper',
                path: '{,*/}%ComponentName%/viewer/%ComponentName%.mapper.ts',
            },
        ],
    },
    corvid: {
        entries: {
            generateParts: false,
            generateComponents: true,
            generateHost: true,
        },
        shouldIncludeComponentsInfo: true,
        getComponentName: function (_a) {
            var componentName = _a.componentName;
            return componentName;
        },
        conventions: [
            {
                part: 'sdk',
                path: '{,*/}%ComponentName%/corvid/%ComponentName%.corvid.ts',
            },
        ],
    },
};
//# sourceMappingURL=hostConfigs.js.map